var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvisSquareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6543",
    "data-name": "Groupe 6543",
    transform: "translate(0 0.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3503",
    "data-name": "Rectangle 3503",
    transform: "translate(0 -0.17)",
    fill: "#d9fdf9",
    stroke: "#3ac1ae",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 86,
    height: 86,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5831",
    "data-name": "Trac\\xE9 5831",
    d: "M38.229,13.85a2.71,2.71,0,0,0-2.372-1.684l-9.92-1.442L21.5,1.735A2.711,2.711,0,0,0,19.165,0a2.711,2.711,0,0,0-2.335,1.735l-4.436,8.989L2.474,12.166A2.71,2.71,0,0,0,.1,13.85a2.711,2.711,0,0,0,.929,2.757l7.179,7L6.515,33.485a2.854,2.854,0,0,0,.5,2.433,2.148,2.148,0,0,0,1.676.751,3.458,3.458,0,0,0,1.6-.44l8.873-4.665,8.874,4.665a3.463,3.463,0,0,0,1.6.44h0a2.147,2.147,0,0,0,1.676-.751,2.853,2.853,0,0,0,.5-2.433L30.121,23.6l7.178-7a2.711,2.711,0,0,0,.929-2.757M35.732,15l-7.6,7.409a1.123,1.123,0,0,0-.323.994L29.6,33.864a1.383,1.383,0,0,1,.009.558,1.379,1.379,0,0,1-.528-.181l-9.4-4.94a1.124,1.124,0,0,0-1.045,0l-9.4,4.94a1.384,1.384,0,0,1-.528.181,1.377,1.377,0,0,1,.009-.558L10.523,23.4a1.124,1.124,0,0,0-.323-.994L2.6,15a1.385,1.385,0,0,1-.336-.446,1.38,1.38,0,0,1,.533-.164L13.3,12.862a1.123,1.123,0,0,0,.846-.614l4.7-9.518a1.379,1.379,0,0,1,.321-.457,1.377,1.377,0,0,1,.321.457l4.7,9.518a1.124,1.124,0,0,0,.846.614l10.5,1.527a1.382,1.382,0,0,1,.534.164,1.39,1.39,0,0,1-.335.446",
    transform: "translate(24.335 24.995)",
    fill: "#3ac1ae"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvisSquareIcon);
export default __webpack_public_path__ + "static/media/avis-square-icon.8c346e9e6ffe2ec429d675a478e03b7e.svg";
export { ForwardRef as ReactComponent };